import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  clients: [],
  tradePartners: [],
  pricing: [],
  isGenerated: false,
  isEditable: true
};

const termsheetPricingSlice = createSlice({
  name: 'termsheetPricing',
  initialState,
  reducers: {
    addClient: (state) => {
      state.clients.push({
        companyName: '',
        address: '',
        countryOfIncorporation: '',
        tradedGoodsDescription: ''
      });
    },
    addTradePartner: (state) => {
      state.tradePartners.push({
        tradePartnerName: '',
        address: '',
        creditLimit: '',
        tenor: '',
        currency: 'USD'
      });
    },
    addPricing: (state) => {
      state.pricing.push({
        discountRateAnnualized: '',
        facilityFee: '',
        processingFee: '',
        facilitySetupFee: '',
        comments: ''
      });
    },
    setClient: (state, action) => {
      const { index, client } = action.payload;
      state.clients[index] = client;
    },
    setTradePartner: (state, action) => {
      const { index, tradePartner } = action.payload;
      state.tradePartners[index] = tradePartner;
    },
    setPricing: (state, action) => {
      const { index, pricing } = action.payload;
      state.pricing[index] = pricing;
    },
    saveAllContent: (state, action) => {
      if (action.payload) {
        const { clients, tradePartners, pricing } = action.payload;
        state.clients = clients;
        state.tradePartners = tradePartners;
        state.pricing = pricing;
        state.isGenerated = true;
        state.isEditable = false;
      }
    },
    resetTermsheetPricing: () => initialState,
    setEditable: (state, action) => {
      state.isEditable = action.payload;
      state.isGenerated = !action.payload;
    }
  }
});

export const {
  addClient,
  addTradePartner,
  addPricing,
  setClient,
  setTradePartner,
  setPricing,
  saveAllContent,
  resetTermsheetPricing,
  setEditable
} = termsheetPricingSlice.actions;

export default termsheetPricingSlice.reducer;
